export default __webpack_public_path__ + "static/feature2-3d96a4dace4043995f028eaf9368920e.mp4";